import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setToken } from "../redux/authenticationSlice"; 
import { useAxios } from "./useAxios";
export const useGet = (path) => {
	const [url, setUrl] = useState(() => "");
	const [error, setError] = useState(() => {});
	const [response, setResponse] = useState(() => {});
	const [loading, setLoading] = useState(() => true);

	// const token = useSelector((state) => state.authentication.token);
	const navigate = useNavigate()
	const dispatch = useDispatch()
	const api = useAxios()

	const get = async () => {
		setLoading(true);
		console.log('url',url)
		try {
			const response = await api.get(url);
			setResponse(response);
			setError(false);
			setLoading(false);
		} catch (ex) {
			setResponse(null);
			console.log(ex.response.data)
			if(ex.response.status === 403 || ex.response.status === 401){
				console.log('navigate')
				// navigate('/')
				// dispatch(setToken(''))
			}
			setError(ex);
			setLoading(false);
		}
	};

	useEffect(() => {
		if (url) {
			get();
		}
	}, [url]);

	useEffect(() => {
		if (!path?.includes("http:") && path) {
			setUrl(process.env.REACT_APP_BACKEND_URL + path);
		} else if(path) {
			setUrl(path);
		}
	}, [path]);

	return {
		loading,
		response,
		error,
	};
};
